import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { DeleteDedicationRequest } from './deletededicationrequest';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export class DeleteDedicationAPI extends SixdeeCRBTAPI<DeleteDedicationRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod()
    {
        return POST;
    }

    getAPIURL(): string
    { 
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/delete-dedication
        return "delete-dedication";
    }

    getRequestData()
    {
        return "aPartyMsisdn=" + this.getRequest().getDeleteDedicationRequest().getAPartyMsisdn() +"&"+
        "bPartyMsisdn=" + this.getRequest().getDeleteDedicationRequest().getBPartyMsisdn() +"&"+
        "timeType="+ this.getRequest().getDeleteDedicationRequest().getTimeType()+"&"+
        "toneId="+ this.getRequest().getDeleteDedicationRequest().getToneId() +"&"+
               "language="+ (this.getRequest().getDeleteDedicationRequest().getLanguage() === LanguageConst.ENGLISH ? "1": "2");
            
            

               
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/mytunes/deletededication/deletededicationapi.tsx